import { render } from "./AuthUser.vue?vue&type=template&id=4832ad72"
import script from "./AuthUser.vue?vue&type=script&lang=js"
export * from "./AuthUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__